export const multiAccount = {
  multi_account: {
    go_back: "Go back",
    current_account: "Current account",
    switch_account: "Switch account",
    add_account: "Add account",
    remove_account: "Sign out of this account",
    logout_current: "Log out of {{email}}",
    logout_all: "Log out of all accounts",
    already_signed_in: "{{email}} is already signed in.",
    logged_out: "{{email}} was logged out because its session expired.",
    impersonate_title: "Add another account?",
    impersonate_message:
      "You're signed in as {{email}}. The impersonated account will be added alongside it, and you can switch back any time from the account menu.",
    impersonate_continue: "Continue",
  },
};
